<div>
  <h1>{{ 'PAGE_PROJECT_DETAILS.title' | translate }}</h1>
  @if (loadingSpinnerService.isSpinnerVisible()) {
    <vwui-spinner></vwui-spinner>
  }
  @if (!loadingSpinnerService.isSpinnerVisible()) {
    @if (projectDetailsValue) {
      <div class="project-overview-banner" data-testid="project-overview-banner">
        <app-project-status [project]="projectDetailsValue"></app-project-status>
        @if (projectVersionLabel) {
          <span class="project-overview-banner__version">
            {{ 'PAGE_PROJECT_DETAILS.version' | translate }}: {{ projectVersionLabel }}
          </span>
        }
      </div>
    <div class="grid">
      <div class="grid__row grid__row--spacing-medium equal-height-row">
        <div class="grid__col grid__col--6 col-general">
          <vwui-card [formGroup]="projectDetailsForm">
            <vwui-card-header>1. {{ 'PAGE_PROJECT_DETAILS.general_title' | translate }}</vwui-card-header>
            <vwui-card-body>
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.name' | translate }}" required>
                <vwui-input formControlName="name"></vwui-input>
              </vwui-form-group>
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.projectPortalCode' | translate }}">
                    <vwui-input
                        type="text"
                        [(ngModel)]="this.projectDetailsValue.projectInfo.projectPortalCode"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="true"
                    ></vwui-input>
              </vwui-form-group>
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.projectType' | translate }}">
                    <vwui-input formControlName="projectType" [disabled]="true"></vwui-input>
              </vwui-form-group>
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.companyName' | translate }}">
                <ng-select [items]="companyNames"
                  [selectOnTab]="true"
                  bindValue="company"
                  labelForId="company"
                  required="true"
                  placeholder="{{ 'PAGE_PROJECT_DETAILS.placeholder.companyName' | translate }}"
                  formControlName="company"
                  >
                </ng-select>
              </vwui-form-group>
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.owner' | translate }}" required>
                <app-user-identity-input
                  [control]="projectDetailsForm.controls.newOwner"
                  [companyType]="companyType"
                  [appDisabledReason]="!ownerChangeable ? ('PAGE_PROJECT_DETAILS.form.owner_disabled' | translate) : ''"
                ></app-user-identity-input>
                @if (ownerChangeable && !!projectDetailsForm.getError('email', 'newOwner')) {
                  <span class="string--limit_reached">{{ 'PAGE_PROJECT_DETAILS.form.emailInvalid' | translate }}</span>
                }
              </vwui-form-group>
              <vwui-form-group class="description-field" label="{{ 'PAGE_PROJECT_DETAILS.form.description.title' | translate }}">
                <vwui-textarea formControlName="description"></vwui-textarea>
              </vwui-form-group>
            </vwui-card-body>
          </vwui-card>
        </div>
        <div class="grid__col grid__col--3  col-location">
          <vwui-card [formGroup]="projectDetailsForm">
            <vwui-card-header>2. {{ 'PAGE_PROJECT_DETAILS.location' | translate }}</vwui-card-header>
            <vwui-card-body>
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.address' | translate }}" required>
                <vwui-input formControlName="address"></vwui-input>
              </vwui-form-group>
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.city' | translate }}" required>
                <vwui-input formControlName="city"></vwui-input>
              </vwui-form-group>
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.location' | translate }}">
                <vwui-input
                    type="text"
                    [(ngModel)]="this.projectDetailsValue.projectInfo.location"
                    [ngModelOptions]="{standalone: true}"
                    [placeholder]="'52.379, 5.228'"
                    [disabled]="true"
                ></vwui-input>
              </vwui-form-group>
              <app-azure-map
                  class="map-preview"
                  [location]="this.projectDetailsValue.projectInfo.location"
                  [interactive]="canEditDetails()"
                  (pinMoved)="onPinMoved($event)"
              ></app-azure-map>
            </vwui-card-body>
          </vwui-card>
        </div>
        <div class="grid__col grid__col--3 col-impression">
          <vwui-card>
            <vwui-card-header>
              3. {{ 'PAGE_PROJECT_DETAILS.impression_title' | translate }}
              @if (canEditDetails()) {
                <vwui-button
                  slot="actions"
                  class="is-secondary"
                  [disabled]="isProcessingThumbnail"
                  [loading]="isProcessingThumbnail"
                  [ariaLabel]="'PAGE_PROJECT_DETAILS.impression_add' | translate"
                  (click)="photoFileInput.click()"
                >
                  {{ 'BUTTON.create' | translate }}
                </vwui-button>
                <input #photoFileInput type="file" accept="image/*" multiple hidden (change)="onAddLocationImages($event)" />
              }
            </vwui-card-header>
            <vwui-card-body>
              @if (projectPhotos().length === 0) {
                <p class="empty-state">{{ 'PAGE_PROJECT_DETAILS.impression_empty' | translate }}</p>
              } @else {
                <div class="photo-carousel">
                  <div class="photo-carousel__preview">
                    <img  [src]="projectPhotos()[activeLocationImageIndex]?.src" alt="" />
                    @if (canEditDetails()) {
                      <button type="button" class="photo-carousel__remove" (click)="removeLocationImage(activeLocationImageIndex, this.projectPhotos()[activeLocationImageIndex]?.id)" [attr.aria-label]="'PAGE_PROJECT_DETAILS.impression_remove' | translate">&times;</button>
                    }
                    @if (projectPhotos().length > 1) {
                      <vwui-btn-icon class="photo-carousel__nav photo-carousel__nav--prev" icon="vwui-chevron-left" [ariaLabel]="'PAGE_PROJECT_DETAILS.impression_previous' | translate" (click)="showPreviousLocationImage()"></vwui-btn-icon>
                      <vwui-btn-icon class="photo-carousel__nav photo-carousel__nav--next" icon="vwui-chevron-right" [ariaLabel]="'PAGE_PROJECT_DETAILS.impression_next' | translate" (click)="showNextLocationImage()"></vwui-btn-icon>
                    }
                  </div>
                  <div class="photo-carousel__dots">
                    @for (image of this.projectPhotos(); track $index) {
                      <button type="button"
                        class="photo-carousel__dot"
                        [class.photo-carousel__dot--active]="$index === activeLocationImageIndex"
                        (click)="setActiveLocationImage($index)"
                        [attr.aria-label]="('PAGE_PROJECT_DETAILS.impression_photo' | translate) + ' ' + ($index + 1)"
                      ></button>
                    }
                  </div>
                </div>
                <p class="photo-carousel__caption">{{ 'PAGE_PROJECT_DETAILS.impression_caption' | translate }}</p>
              }
            </vwui-card-body>
          </vwui-card>
        </div>
      </div>

      <div class="grid-spacer grid-spacer--medium"></div>
      <vwui-card>
        <vwui-card-header>4. {{ 'PAGE_PROJECT_DETAILS.characteristics_title' | translate }}</vwui-card-header>
        <vwui-card-body>
          <div class="grid">
            <div class="grid__row grid__row--spacing-large grid__row--align-inputs">
              <div class="grid__col grid__col--third grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.numberOfUnits' | translate }}">
                    <vwui-input-mask
                        [mask]="numberOfUnitsMask"
                        type="number"
                        [(ngModel)]="this.projectDetailsValue.projectInfo.numberOfUnits"
                        [disabled]="!this.canEditDetails()"
                    ></vwui-input-mask>
                </vwui-form-group>
              </div>
              <div class="grid__col grid__col--third grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.commercialSpace' | translate }}">
                    <vwui-input-mask
                        [mask]="{alias: 'decimal', groupSeparator: '.', radixPoint: ',', digits: 2, min: 0}"
                        type="number"
                        [(ngModel)]="this.projectDetailsValue.projectInfo.commercialSpace"
                        [disabled]="!this.canEditDetails()"
                    ></vwui-input-mask>
                </vwui-form-group>
              </div>
              <div class="grid__col grid__col--third grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.bvo' | translate }}" required>
                    <vwui-input-mask
                        [mask]="{alias: 'decimal', groupSeparator: '.', radixPoint: ',', digits: 2, min: 0}"
                        type="number"
                        [(ngModel)]="this.projectDetailsValue.projectInfo.bvo"
                        [disabled]="!this.canEditDetails()"
                    ></vwui-input-mask>
                </vwui-form-group>
              </div>
            </div>
            @if (projectAttributes$ | async; as attributes) {
              <div class="grid__row grid__row--spacing-large">
                <div class="grid__col grid__col--third grid__col--spacing-large">
                  <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.workType' | translate }}">
                      <ng-select [items]="attributes.workTypes"
                          [selectOnTab]="true"
                          [multiple]="true"
                          bindLabel="title"
                          bindValue="id"
                          labelForId="workType"
                          placeholder="{{ 'PAGE_PROJECT_DETAILS.placeholder.workType' | translate }}"
                          [(ngModel)]="this.projectDetailsValue.projectInfo.workTypes"
                          [disabled]="!this.canEditDetails()"
                      ></ng-select>
                  </vwui-form-group>
                </div>
                <div class="grid__col grid__col--third grid__col--spacing-large">
                  <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.buildingClassification' | translate }}">
                      <ng-select [items]="attributes.buildingClassifications"
                          [selectOnTab]="true"
                          [multiple]="true"
                          bindLabel="title"
                          bindValue="id"
                          labelForId="buildingClassification"
                          placeholder="{{ 'PAGE_PROJECT_DETAILS.placeholder.buildingClassification' | translate }}"
                          [(ngModel)]="this.projectDetailsValue.projectInfo.buildingClassifications"
                          [disabled]="!this.canEditDetails()"
                      ></ng-select>
                  </vwui-form-group>
                </div>
                <div class="grid__col grid__col--third grid__col--spacing-large">
                  <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.buildingSubClassification' | translate }}">
                      <ng-select [items]="availableBuildingSubClassifications(attributes)"
                          [selectOnTab]="true"
                          [multiple]="true"
                          bindLabel="title"
                          bindValue="id"
                          labelForId="buildingSubClassification"
                          placeholder="{{ 'PAGE_PROJECT_DETAILS.placeholder.buildingSubClassification' | translate }}"
                          [(ngModel)]="this.projectDetailsValue.projectInfo.buildingSubClassifications"
                          [disabled]="!this.canEditDetails()"
                      ></ng-select>
                  </vwui-form-group>
                </div>
              </div>
            }
          </div>
        </vwui-card-body>
      </vwui-card>

      <div class="grid-spacer grid-spacer--medium"></div>
      <vwui-card>
        <vwui-card-header>5. {{ 'PAGE_PROJECT_DETAILS.planning_title' | translate }}</vwui-card-header>
        <vwui-card-body>
          <div class="grid">
            <div class="grid__row grid__row--spacing-large grid__row--align-inputs">
              <div class="grid__col grid__col--3 grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.designStartsAt' | translate }}">
                  <vwui-datepicker
                    [ngClass]="{'disabled': !canEditDetails()}"
                    [disabled]="!this.canEditDetails()"
                    [flatpickrOptions]="{dateFormat: 'Y-m-d', altFormat: 'd-m-Y', altInput: true, convertModelValue: true, allowInput: true, locale: 'nl'}"
                    [(ngModel)]="this.projectDetailsValue.projectInfo.designStartsAt"
                  ></vwui-datepicker>
                </vwui-form-group>
              </div>
              <div class="grid__col grid__col--3 grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.executionStartsAt' | translate }}">
                  <vwui-datepicker
                    [ngClass]="{'disabled': !canEditDetails()}"
                    [disabled]="!this.canEditDetails()"
                    [flatpickrOptions]="{dateFormat: 'Y-m-dTH:i', altFormat: 'd-m-Y', altInput: true, convertModelValue: true, allowInput: true, locale: 'nl'}"
                    [(ngModel)]="startDate"
                    [maxDate]="endDate"
                  ></vwui-datepicker>
                </vwui-form-group>
              </div>
              <div class="grid__col grid__col--3 grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.finalDeliveryAt' | translate }}">
                  <vwui-datepicker
                    [ngClass]="{'disabled': !canEditDetails()}"
                    [disabled]="!this.canEditDetails()"
                    [flatpickrOptions]="{dateFormat: 'Y-m-dTH:i', altFormat: 'd-m-Y', altInput: true, convertModelValue: true, allowInput: true, locale: 'nl'}"
                    [(ngModel)]="endDate"
                    [minDate]="startDate"
                  ></vwui-datepicker>
                </vwui-form-group>
              </div>
              <div class="grid__col grid__col--3 grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.durationInMonths' | translate }}">
                  <vwui-input [ngModel]="durationInMonths" disabled="true"></vwui-input>
                </vwui-form-group>
              </div>
            </div>
            <div class="grid__row grid__row--spacing-large grid__row--align-inputs">
              <div class="grid__col grid__col--3 grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.numberOfPhases' | translate }}">
                    <vwui-input
                        type="number"
                        [min]="0"
                        [(ngModel)]="this.projectDetailsValue.projectInfo.numberOfPhases"
                        [disabled]="!this.canEditDetails()"
                    ></vwui-input>
                </vwui-form-group>
              </div>
            </div>
          </div>
        </vwui-card-body>
      </vwui-card>

      <div class="grid-spacer grid-spacer--medium"></div>
      <vwui-card>
        <vwui-card-header>6. {{ 'PAGE_PROJECT_DETAILS.financial_title' | translate }}</vwui-card-header>
        <vwui-card-body>
          <div class="grid">
            <ng-container [formGroup]="costsForm">
              <div class="grid__row grid__row--spacing-large grid__row--align-inputs">
                <div class="grid__col grid__col--third grid__col--spacing-large">
                  <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.constructionCostsEstimate' | translate }}" required>
                    <div class="sc-vwui-input-h sc-vwui-input-s vwui-container sc-vwui-input" [ngClass]="{'disabled': !canEditDetails() }">
                      <input class="sc-vwui-input" type="text" formControlName="constructionCosts" [placeholder]="'PAGE_PROJECT_DETAILS.placeholder.constructionCosts' | translate" [readOnly]="!this.canEditDetails()" [disabled]="!this.canEditDetails()" />
                    </div>
                  </vwui-form-group>
                  <!-- Winstbijdrage: hidden for now -->
                  @if (false) {
                    <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.profitContribution' | translate }}">
                      <div class="sc-vwui-input-h sc-vwui-input-s vwui-container sc-vwui-input" [ngClass]="{'disabled': !canEditDetails() }">
                        <input class="sc-vwui-input" type="text" formControlName="profitContribution" [placeholder]="'PAGE_PROJECT_DETAILS.placeholder.profitContribution' | translate" [readOnly]="!this.canEditDetails()" [disabled]="!this.canEditDetails()" />
                      </div>
                    </vwui-form-group>
                  }
                </div>
                <div class="grid__col grid__col--third grid__col--spacing-large">
                  <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.tenderCosts' | translate }}" required>
                      <ng-select [items]="tenderCostsRanges"
                          [selectOnTab]="true"
                          [searchable]="false"
                          bindLabel="label"
                          bindValue="value"
                          labelForId="tenderCosts"
                          [(ngModel)]="tenderCostsRange"
                          [ngModelOptions]="{standalone: true}"
                          [disabled]="!this.canEditDetails()"
                      ></ng-select>
                  </vwui-form-group>
                </div>
                <div class="grid__col grid__col--third grid__col--spacing-large">
                  <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.tenderDate' | translate }}" required>
                      <vwui-datepicker
                          [ngClass]="{'disabled': !canEditDetails()}"
                          [disabled]="!this.canEditDetails()"
                          [flatpickrOptions]="{dateFormat: 'Y-m-d', altFormat: 'd-m-Y', altInput: true, convertModelValue: true, allowInput: true, locale: 'nl'}"
                          [(ngModel)]="this.projectDetailsValue.projectInfo.tenderDate"
                          [ngModelOptions]="{standalone: true}"
                      ></vwui-datepicker>
                  </vwui-form-group>
                </div>
              </div>
            </ng-container>
          </div>
        </vwui-card-body>
      </vwui-card>

      <div class="grid-spacer grid-spacer--medium"></div>
      <vwui-card>
        <vwui-card-header>7. {{ 'PAGE_PROJECT_DETAILS.client_collaboration_title' | translate }}</vwui-card-header>
        <vwui-card-body class="client-collaboration-body">
          <div class="grid">
            <div class="grid__row grid__row--spacing-large grid__row--align-inputs">
              <div class="grid__col grid__col--third grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.client' | translate }}" required>
                  <vwui-input [ngClass]="stringLimitReached('client') ? 'input-limit-reached' : ''"
                    [(ngModel)]="projectDetailsValue.projectInfo.client"
                    [placeholder]="'PAGE_PROJECT_DETAILS.placeholder.client' | translate"
                  [disabled]="!this.canEditDetails()"></vwui-input>
                </vwui-form-group>
              </div>
              <div class="grid__col grid__col--third grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.developer' | translate }}">
                    <vwui-input
                        type="text"
                        [(ngModel)]="this.projectDetailsValue.projectInfo.developer"
                        [disabled]="!this.canEditDetails()"
                    ></vwui-input>
                </vwui-form-group>
              </div>
              <div class="grid__col grid__col--third grid__col--spacing-large">
                <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.clientOther' | translate }}">
                    <vwui-input
                        type="text"
                        [(ngModel)]="this.projectDetailsValue.projectInfo.clientOther"
                        [disabled]="!this.canEditDetails()"
                    ></vwui-input>
                </vwui-form-group>
              </div>
            </div>
          </div>
        </vwui-card-body>
      </vwui-card>
        <div class="grid-spacer grid-spacer--medium"></div>

      <vwui-card>
        <vwui-card-header>8. {{ 'PAGE_PROJECT_DETAILS.design_parties_title' | translate }}</vwui-card-header>
        <vwui-card-body>
          <div class="design-parties-row">
            <div class="design-parties-row__col">
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.architect' | translate }}">
                  <vwui-textarea
                      autosize
                      [(ngModel)]="this.projectDetailsValue.projectInfo.architect"
                      [ngModelOptions]="{standalone: true}"
                      [disabled]="!this.canEditDetails()"
                  ></vwui-textarea>
              </vwui-form-group>
            </div>
            <div class="design-parties-row__col">
              <vwui-form-group label="{{ 'PAGE_PROJECT_DETAILS.form.constructor' | translate }}">
                  <vwui-textarea
                      autosize
                      [(ngModel)]="this.projectDetailsValue.projectInfo.constructor"
                      [ngModelOptions]="{standalone: true}"
                      [disabled]="!this.canEditDetails()"
                  ></vwui-textarea>
              </vwui-form-group>
            </div>
          </div>
        </vwui-card-body>
      </vwui-card>
        <div class="grid-spacer grid-spacer--medium"></div>

        <div class="col-attachments_and_notes">
            <app-project-attachments-card [projectDetails]="projectDetailsValue"></app-project-attachments-card>
            <app-project-notes-card [projectDetails]="projectDetailsValue"></app-project-notes-card>
        </div>
    </div>
    }
  }
</div>
